<template>
  <CCard v-if="promotionUsages && promotionUsages.length > 0" class="mb-4">
    <CCardHeader>
      <h5 class="mb-0">
        <CIcon name="cilGift" class="mr-2"/>
        <translate translate-context="edge-orders.promotions">Promotions Applied</translate>
      </h5>
    </CCardHeader>
    <CCardBody class="p-0">
      <CDataTable
        :items="promotionUsages"
        :fields="fields"
        hover
        striped
        border
      >
        <template #name="{item}">
          <td>
            <CIcon name="cilTag" class="text-success mr-2"/>
            <strong>{{ item.promotion_rule_snapshot.name }}</strong>
          </td>
        </template>
        <template #discount="{item}">
          <td class="text-right">
            <span class="text-success font-weight-bold">
              -{{ item.discount_amount | currency(currency) }}
            </span>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
import Filters from '@/domain/core/utils/filters'

export default {
  name: 'PromotionsApplied',
  props: {
    promotionUsages: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String,
      default: 'EUR'
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'name',
          label: this.$pgettext('edge-orders.promotions', 'Promotion Name')
        },
        {
          key: 'discount',
          label: this.$pgettext('edge-orders.promotions', 'Discount'),
          _classes: 'text-right'
        }
      ]
    }
  },
  filters: {
    currency: Filters.currency
  }
}
</script>

<style scoped>
.font-weight-bold {
  font-weight: 700;
}
</style>
